/**
 * Promotions Data
 * Phase D2.3: Cinematic Promotions Carousel
 */

export interface Promotion {
  id: string;
  title: string;
  tagline: string;
  description: string;
  imageUrl: string;
  gradient: string; // For overlay effect
}

export const promotions: Promotion[] = [
  {
    id: 'promo_spa',
    title: 'Spa Escape Package',
    tagline: 'Relax, recharge, renew',
    description: 'Full-day spa access with signature treatment',
    imageUrl: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&h=600&fit=crop',
    gradient: 'from-black/90 via-black/50 to-transparent',
  },
  {
    id: 'promo_rooftop',
    title: 'Rooftop Sunset Cocktails',
    tagline: 'Golden hour, elevated',
    description: 'Complimentary cocktail at our panoramic terrace',
    imageUrl: 'https://images.unsplash.com/photo-1470337458703-46ad1756a187?w=800&h=600&fit=crop',
    gradient: 'from-black/90 via-black/50 to-transparent',
  },
  {
    id: 'promo_green',
    title: 'Green Stay Rewards',
    tagline: 'Save the planet. Get rewarded.',
    description: 'Earn points for eco-friendly choices',
    imageUrl: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=800&h=600&fit=crop',
    gradient: 'from-black/90 via-black/50 to-transparent',
  },
  {
    id: 'promo_tour',
    title: 'Private City Tour',
    tagline: 'Discover Lisbon like a local',
    description: 'Exclusive guided tour with our concierge',
    imageUrl: 'https://images.unsplash.com/photo-1585208798174-6cedd86e019a?w=800&h=600&fit=crop',
    gradient: 'from-black/90 via-black/50 to-transparent',
  },
];
